import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import TextChip from '../TextChip/TextChip';
import Button from '../Button';
import Modal from '../Modal';
import { SelectButtonIcon } from '../SelectButton';
import PortalMenu from '../PortalMenu';
import styles from './MultiSelect.module.css';
import { classNames } from '../../utils';
class MultiSelect extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            focus: false,
            active: false,
        };
        this.containerRef = React.createRef();
        this.inputRef = React.createRef();
        this.handleClickOutside = (event) => {
            if (this.props.selectionComponentType === 'modal')
                return;
            if (this.containerRef.current &&
                !this.containerRef.current.contains(event.target)) {
                this.onBlur();
            }
        };
        this.onFocus = () => {
            this.setState({ focus: true, active: true });
            if (this.inputRef.current) {
                this.inputRef.current.focus();
            }
        };
        this.onBlur = () => {
            this.setState({ focus: false, active: false });
        };
        this.renderTextChips = () => {
            const { items = [], onDeleteItem, maxDisplayedItems = 5 } = this.props;
            return (_jsxs(_Fragment, { children: [items.slice(0, maxDisplayedItems).map((item) => (_jsx("li", { children: _jsx(TextChip, { itemId: item.id, label: item.value, className: item.className, onDelete: onDeleteItem }, void 0) }, item.id))), items.length > maxDisplayedItems && (_jsxs("div", Object.assign({ onClick: this.onFocus, className: styles.moreText }, { children: ["+", items.length - maxDisplayedItems, " more"] }), void 0))] }, void 0));
        };
        this.onClickApply = () => {
            const { onSelection } = this.props;
            if (onSelection) {
                onSelection();
            }
            this.onBlur();
        };
        this.renderSelectButtonAndLabels = () => {
            const { inputValue, onInputChange, error = false, items = [] } = this.props;
            return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.selectButton, onClick: this.onFocus, "data-testid": this.props['data-testid'] || 'multiSelect-button' }, { children: [_jsx(SelectButtonIcon, { variant: "select" }, void 0), _jsx("input", { placeholder: "- Select -", className: `${styles.input} ${error && styles.hasError}`, value: inputValue, onChange: onInputChange, readOnly: !inputValue && !onInputChange, ref: this.inputRef }, void 0)] }), void 0), items.length > 0 && (_jsx("ul", Object.assign({ onClick: this.onFocus }, { children: this.renderTextChips() }), void 0))] }, void 0));
        };
        this.renderSelectionComponent = () => {
            const { selectButton, selectionComponent, selectionComponentType, doNotIncludeActions, selectionComponentClassName, limitDropdownWidth, } = this.props;
            const actions = [
                _jsx(Button, Object.assign({ onClick: this.onBlur, variant: "text" }, { children: "Cancel" }), "eb_multiselect_cancel"),
                _jsx(Button, Object.assign({ onClick: this.onClickApply }, { children: "Apply" }), "eb_multiselect_submit"),
            ];
            const renderContent = (_jsxs("div", { children: [selectionComponent, selectionComponentType !== 'modal' && !doNotIncludeActions && (_jsx("div", Object.assign({ className: styles.buttonContainer }, { children: actions }), void 0))] }, void 0));
            switch (selectionComponentType) {
                case 'modal':
                    return (_jsx(Modal, Object.assign({ className: selectionComponentClassName, actions: actions, onClose: this.onBlur }, { children: renderContent }), void 0));
                case 'portalDropdown':
                    return (_jsx(PortalMenu, Object.assign({ buttonContent: selectButton || this.renderSelectButtonAndLabels(), listClassName: classNames(styles.portalDropdownItemsList, limitDropdownWidth ? styles.limitWidth : '') }, { children: renderContent }), void 0));
                case 'dropdown':
                default:
                    return (_jsx("div", Object.assign({ className: `${styles.dropdown} ${selectionComponentClassName}` }, { children: renderContent }), void 0));
            }
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate(prevProps) {
        const { items: prevItems } = prevProps;
        const { items } = this.props;
        if ((prevItems || []).length < (items || []).length) {
            this.setState({
                active: false,
            });
        }
    }
    render() {
        const { focus, active } = this.state;
        const { selectionComponentType, error = false, customErrorText = 'Invalid field', selectButton, hideSelection, className, } = this.props;
        return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: classNames(styles.container, focus ? styles.focus : '', active ? styles.active : '', error ? styles.hasErrorBorder : '', hideSelection ? styles.hideSelection : '', className), ref: this.containerRef }, { children: [selectionComponentType !== 'portalDropdown' &&
                            (selectButton || this.renderSelectButtonAndLabels()), (active || selectionComponentType === 'portalDropdown') &&
                            this.renderSelectionComponent()] }), void 0), error ? (_jsx("div", Object.assign({ className: styles.invalidText }, { children: customErrorText }), void 0)) : null] }, void 0));
    }
}
export default MultiSelect;
